module.exports = __webpack_public_path__ + "static/media/blom-pysanky-119.b3ce2df9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blom-pysanky/blom-pysanky-119.jpg
// module id = 3682
// module chunks = 13